import { extractFilesFromFormData, validateCartHasImages } from '../utilities/atcViaFromDataValidation';
import { CartItem } from './addToCart';

interface validateAndTryAgainProps {
  // The cart items live in the cart.
  cartItems: CartItem[];
  // The form data from the original add to cart form.
  formData: FormData;
}
export const validateAndTryAgain = async ({ cartItems, formData }: validateAndTryAgainProps) => {
  const formDataFiles = extractFilesFromFormData(formData, 0);
  // Find the item that has just been added to the cart.
  const addedItems = cartItems?.filter((item: CartItem) => {
    const { properties: { _check_id } = { _check_id: null } } = item;

    return formData.get(`items[0][properties][_check_id]`) === _check_id;
  });

  const itemsToRemove = addedItems
    ?.map((item: CartItem) => {
      const { requiresReAddingProduct, key } = validateCartHasImages({
        formDataFiles,
        addedItem: item
      });
      return { requiresReAddingProduct, key: item.key };
    })
    .filter((item: { requiresReAddingProduct: boolean; key: string | null }) => item.requiresReAddingProduct);

  return itemsToRemove;
};
